import { QUERY_KEYS } from '~/constants/react-query'
import { useQueryWrapper } from '~/hooks/useQueryWrapper'
import { useServerRequests } from '~/hooks/useRequests'

export type PlanName = 'base' | 'pro' | 'premium'

export type PaidPlanName = Exclude<PlanName, 'base'>

export type Plan = {
  /** Stable server id; the subscribe endpoint keys on this, not the name */
  id: number
  name: PlanName
  rank: number
  /** Minimum Earn balance in USD that qualifies */
  earnMinimum: number
  /** Annual subscription price in USDC */
  subscriptionPrice: number
}

type PlansResponse = {
  plans: Plan[]
  /** ISO timestamp when plan requirements start being enforced */
  enforcementDate: string
}

export const usePlans = () => {
  const { serverGetRequest } = useServerRequests()

  const { data, isLoading, isFetching, isError, refetch } =
    useQueryWrapper<PlansResponse>({
      queryKey: [QUERY_KEYS.PLANS],
      queryFn: async () => {
        const result = await serverGetRequest<PlansResponse>({
          path: '/api/public/plans',
        })
        if (!result) throw new Error('Failed to fetch plans')
        if (!Number.isFinite(Date.parse(result.data.enforcementDate))) {
          throw new Error('Invalid plan enforcement date')
        }
        return result.data
      },
    })

  return {
    plans: data?.plans ?? [],
    enforcementDate: data?.enforcementDate,
    isLoading,
    isFetching,
    isError,
    refetch,
  }
}
